module.exports = __webpack_public_path__ + "static/img/10bg_7.8ce80a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_7.png
// module id = 623
// module chunks = 1